import { module } from 'modujs';
import gsap from "gsap";
import { $body } from '../utils/dom';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.addEventListener('p-loaded', () => {
            setTimeout(() => {
                this.initTL();
            }, 400);
        });
        window.addEventListener('p-animate', () => {
            this.animate();
        });
    }

    initTL() {
        if ($body.classList.contains('home')) {
            this.TL = this.animateHome();
        }
        // else if ($body.classList.contains('page-template-tpl-xxx')) {
        //     this.TL = this.animateXxx();
        // }
        else if ($body.classList.contains('page-template-default')) {
            this.TL = this.animateDefault();
        }
    }

    animate() {
        if (this.TL) {
            this.TL.play();
        }
    }

    animateHome() {
        let tl = gsap.timeline({ paused: true });
        let delay = 0;
        
        if (this.el.querySelector('.-h1')) {
            tl.call(() => {
                this.el.querySelector('.-h1').classList.add('is-inview')
            }, null, delay);
        }

        return tl;
    }

    animateXxx() {
        let tl = gsap.timeline({ paused: true });
        let delay = 0;
        
        // if (this.el.querySelector('.o-header .-surtitle')) {
        //     tl.call(() => {
        //         this.el.querySelector('.o-header .-surtitle').classList.add('is-inview')
        //     }, null, 0);
        //     delay += 0.3;
        // }

        // if (this.el.querySelector('.o-header .-h1')) {
        //     tl.call(() => {
        //         this.el.querySelector('.o-header .-h1').classList.add('is-inview')
        //     }, null, delay);
        // }

        // if (this.el.querySelector('.o-header .c-button-icon')) {
        //     tl.fromTo(
        //         this.el.querySelector('.o-header .c-button-icon'),
        //         { scale: 0 },
        //         { scale: 1, duration: 0.6, ease: 'expo.out' },
        //         1
        //     );
        // }

        return tl;
    }

    animateDefault() {
        let tl = gsap.timeline({ paused: true });
        let delay = 0;
        
        // if (this.el.querySelector('.o-header .-surtitle')) {
        //     tl.call(() => {
        //         this.el.querySelector('.o-header .-surtitle').classList.add('is-inview')
        //     }, null, delay);
        //     delay += 0.2;
        // }

        // if (this.el.querySelector('.o-header .-h2')) {
        //     tl.call(() => {
        //         this.el.querySelector('.o-header .-h2').classList.add('is-inview')
        //     }, null, delay);
        //     delay += 0.2;
        // }
        
        // if (this.el.querySelector('.o-header .-c2')) {
        //     tl.call(() => {
        //         this.el.querySelector('.o-header .-c2').classList.add('is-inview')
        //     }, null, delay);
        // }

        // tl.call(() => {
        //     this.el.querySelector('.o-page_contents').classList.add('is-inview')
        // }, null, delay);

        return tl;
    }
}
